import { gql } from "@apollo/client";

export const UPDATE_GESTION_CREDITICIA = gql`
mutation UpdateGestionCrediticia (
    $idEvaluacion: Int! 
    $idEstadoCrediticio: Int!
) {
    updateEvaluacionGestionCrediticia (
        idEvaluacion: $idEvaluacion 
        idEstadoCrediticio: $idEstadoCrediticio
    ) {
        idEvaluacion
    }
}
`;